import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  QueryResult,
} from '@apollo/client';

import { useGraphql } from '@sbu/contexts.graphql';
import { QueryOptions, useQuery as useQueryOriginal } from '@sbu/hooks.graphql';

export const useQuery = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables> & QueryOptions
): QueryResult<TData, TVariables> => {
  const { enableSplitHttpLink } = useGraphql();

  return useQueryOriginal<TData, TVariables>(query, {
    notifyErrors: false,
    ...options,
    context: {
      targetGraph: 'ADMIRAL',
      enableSplitHttpLink,
      ...options?.context,
    },
  });
};
